import React from "react";
import { Navigate } from "react-router";
import PublicLayout from "../App/PublicLayout/PublicLayout";
import useAppContext from "../App/useAppContext";
import { rootPaths } from "./routesPaths";

const PublicRoute = ({ children }) => {
  const hasToken = !!useAppContext().userToken;

  if (hasToken) {
    return <Navigate to={rootPaths.HOME} replace />;
  }

  return <PublicLayout>{children}</PublicLayout>;
};

export default PublicRoute;
